<template>
	<div class="we-toggle-triple-switch">
		<div :class="{ active: this.fastFilterDateInterval === 'now' }" @click="manageFastFilterSelected('now')" >
			Actualidad
		</div>
		<div :class="{ active: this.fastFilterDateInterval === 'lastMonth' }" @click="manageFastFilterSelected('lastMonth')">
			Último mes
		</div>
		<div :class="{ active: this.fastFilterDateInterval === 'last3Months' }" @click="manageFastFilterSelected('last3Months')">
			Últimos 3 meses
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			fastFilterDateInterval: 'now',
		};
	},
	methods: {
		manageFastFilterSelected(optionSelected) {
			this.fastFilterDateInterval = optionSelected;
			this.$emit('FastFilterChanged', optionSelected);
		},
		updateFilterSelection(selectedFilter) {
			this.fastFilterDateInterval = selectedFilter;
		}
	},
};
</script>
